export default __webpack_public_path__ + "static/media/undraw_Progress_indicator_re_4o4n.0b937b8f.svg";